import { render, staticRenderFns } from "./bscClueOnlineMatrixList.vue?vue&type=template&id=6b8a65b1&scoped=true"
import script from "./bscClueOnlineMatrixList.vue?vue&type=script&lang=js"
export * from "./bscClueOnlineMatrixList.vue?vue&type=script&lang=js"
import style0 from "./bscClueOnlineMatrixList.vue?vue&type=style&index=0&id=6b8a65b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8a65b1",
  null
  
)

export default component.exports